import { z } from 'zod';

export const UUID = z.string().uuid();

// eslint-disable-next-line no-redeclare
export type UUID = z.infer<typeof UUID>;
